import React from "react";
import { Card, Typography } from "antd";

const ContactPage = () => (
  <div className="policy-container">
    <Card>
      <Typography.Title level={2}>Contact Us</Typography.Title>

      <Typography.Paragraph>
        <strong>Dropkart India Pvt. Ltd</strong><br />
        NR Peta, Kurnool, Andhra Pradesh, 518001, India<br /><br />

        <strong>Email:</strong> dropkartworld29@gmail.com<br />
        <strong>Phone:</strong> +91 90322 25598<br /><br />

        Customer Support Hours: Monday–Saturday, 10 AM - 7 PM IST
      </Typography.Paragraph>
    </Card>
  </div>
);

export default ContactPage;
